import React from "react";
import { Link } from "react-router-dom";
import BoomLogicIcon from "../../assets/icons/create_boomlogic.svg2";
import BroadcastIcon from "../../assets/icons/create_broadcast.svg2";
import InboundIcon from "../../assets/icons/create_inbound.svg2";
import ApiIcon from "../../assets/icons/create_api_connection.svg2";
import ReportingOverview from "./ReportingOverview";
import RequiringAttention from "./RequiringAttention";
import MyIcon from "../Common/MyIcon";
import WidgetContainer from "../Common/WidgetContainer";
import { useGetUserDataQuery } from "../store/slices/settingsSlice";
import BoomLogicDropdown from "./BoomLogicDropdown";
import { Icons } from "react-toastify";
import CreateABroadcastDropdown from "./CreateABroadcastDropdwn";
import CreateACampaignDropdown from "./CreateACampaignDropdown";
import CreateAnApiConnectionDropdown from "./CreateAnApiConnectionDropdown";
import PersonalDetailsModal from "../Settings/PersonalDetailsModal";
import NewFeature from "../Builder/Components/NewFeature";
import DataImportModal from "../Common/DataImportModal/DataImportModal";
import InboundCampaignForm from "../Inbounds/InboundCampaignForm";
import HelpButton from "../HelpContent/HelpButton";
import { Overlay, OverlayTrigger } from "react-bootstrap";
import MyModal from "../Common/MyModal";
import LightBroadcast from "../Broadcast/LightBroadcast";
import BroadcastPage from "../Broadcast/BroadcastPage";

const { user } = JSON.parse(document.querySelector("#app").dataset.page).props;

const defaultWidgetLayout = [
  { i: "./ActiveUsersWidget.jsx", x: 0, y: 0, w: 5, h: 10 },
  { i: "./MessagesWidget.jsx", x: 5, y: 0, w: 5, h: 10 },
  { i: "./MessagesProcessedWidget.jsx", x: 10, y: 0, w: 5, h: 10 },
  { i: "./SystemUsageWidget.jsx", x: 15, y: 0, w: 5, h: 10 },
  { i: "./ContactsAndAssetsMapWidget.jsx", x: 0, y: 10, w: 20, h: 20 },
];

export default function Dashboard() {
  return (
    <div>
      <div className="row my-3">
        <div className="col-xl-4 border-end border-1 mt-2">
          <span className="bg-colored text-white text-spaced btn-sm fw-bold px-4 mb-3 rounded-pill py-1">
            DASHBOARD
          </span>
          <div className="my-3">
            <h1 className="fw-bold display-5 m-0"> Welcome</h1>
            <h1 className="fw-bold display-5 m-0">
              back, <PersonalDetailsModal />
            </h1>

            <h3 className="text-secondary">
              Nice to see you again, enjoy your dashboard.
            </h3>
          </div>
        </div>
        <div className="col-xl-8">
          <div className="mb-3">
            <h3 className="fw-bold">Get started with</h3>
            <p className="opacity-50">A communications process</p>
          </div>
          <div className="row text-center g-4 align-items-stretch">
            <div className="col">
              <NewFeature showDisabled>
                <Link
                  to="/create/project/wizard/attributes"
                  className="btn btn-white rounded-3 py-3 h-100 w-100"
                >
                  <div className="text-center">
                    <BoomLogicIcon width={50} />
                    <div className="mt-2">
                      <span className="small"> CREATE A</span>
                      <div className="fw-bold fs-5 mb-2">
                        boomLogic Project
                        <HelpButton helpKey="create-boomlogic-project-overview" />
                      </div>
                    </div>
                    <BoomLogicDropdown />
                  </div>
                </Link>
              </NewFeature>
            </div>
            <div className="col">
              <Link
                to="/library/broadcast/new/settings"
                className="btn btn-white rounded-3 py-3 h-100 w-100"
              >
                <div className="d-flex flex-column h-100 text-center align-items-center">
                  <BroadcastIcon width={50} />
                  <div className="mt-2">
                    <span className="small"> CREATE A </span>
                    <div className="fw-bold fs-5 mb-2">
                      Broadcast
                      <button
                        type="button"
                        className="btn p-0"
                        onClick={(e) => {
                          alert("help");
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <HelpButton helpKey="create-broadcast-overview" />
                      </button>
                    </div>
                  </div>
                  <div className="flex-grow-1"></div>
                  <div className="align-self-stretch">
                    <CreateABroadcastDropdown />
                  </div>
                </div>
              </Link>
            </div>
            <div className="col">
              <InboundCampaignForm
                uuid="new"
                showButton={
                  <span className="btn btn-white rounded-3 py-3 h-100 w-100">
                    <div className="d-flex flex-column h-100 text-center align-items-center">
                      <InboundIcon width={50} />
                      <div className="mt-2">
                        <span className="small"> CREATE A </span>
                        <div className="fw-bold fs-5 mb-2">
                          {" "}
                          Campaign{" "}
                          <HelpButton helpKey="create-campaign-overview" />
                        </div>
                      </div>
                      <div className="flex-grow-1"></div>
                      <div
                        className="align-self-stretch"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <CreateACampaignDropdown />
                      </div>
                    </div>
                  </span>
                }
              />
            </div>
            <div className="col">
              <DataImportModal
                apiUuid="add"
                showButton={
                  <span className="btn btn-white rounded-3 py-3 h-100 w-100">
                    <div className="text-center">
                      <ApiIcon width={50} />
                      <div className="mt-2">
                        <span className="small"> CREATE AN </span>
                        <div className="fw-bold fs-5 mb-2">
                          API Connection{" "}
                          <HelpButton helpKey="create-api-connection-overview" />
                        </div>
                      </div>
                      {/* <div onClick={(e) => e.stopPropagation()}>
                        <CreateAnApiConnectionDropdown />
                      </div> */}
                    </div>
                  </span>
                }
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="text-secondary" />
      {/* <div className="row row-cols-xxl-5 row-cols-lg-3 row-cols-1 g-1 my-5"> */}
      <WidgetContainer
        defaultLayout={defaultWidgetLayout}
        lsField="dashboardWidgetLayout"
      />
      {/* </div> */}
      <div className="row mb-5">
        <div className="col-xl-12">
          <ReportingOverview />
        </div>
        {/* <div className="col-xl-3"> 
          <RequiringAttention />
        </div> */}
      </div>
    </div>
  );
}
